import script from "./ArgusSnapshot.vue?vue&type=script&setup=true&lang=js"
export * from "./ArgusSnapshot.vue?vue&type=script&setup=true&lang=js"

import "./ArgusSnapshot.vue?vue&type=style&index=0&id=476fe28c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-476fe28c"]])

export default __exports__